/*! The Sleep Club — Shopify theme JS
 *  Vanilla JS, ES2018-compatible. Re-initializes on shopify:section:load.
 */

(function () {
  'use strict';

  // ============================================================
  // Helpers
  // ============================================================
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }
  function off(el, evt, fn) { if (el) el.removeEventListener(evt, fn); }
  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.currency && window.Shopify.currency.format) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  // ============================================================
  // Section registry — each entry can have init / destroy
  // ============================================================
  var Sections = {};
  function register(type, init) {
    Sections[type] = init;
  }
  function initSection(root) {
    var type = root.getAttribute('data-section-type');
    var fn = Sections[type];
    if (typeof fn === 'function') fn(root);
  }
  function initAllSections(root) {
    root = root || document;
    $$('[data-section-type]', root).forEach(initSection);
  }

  // ============================================================
  // Reveal animations (IntersectionObserver)
  // ============================================================
  var revealObserver = null;
  function setupRevealObserver() {
    if (revealObserver) return;
    if (typeof IntersectionObserver === 'undefined') {
      $$('.reveal, .reveal-left, .reveal-right, .reveal-scale, .stagger-children').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { root: null, rootMargin: '0px 0px -60px 0px', threshold: 0.1 });
  }
  function observeReveals(root) {
    setupRevealObserver();
    if (!revealObserver) return;
    var sel = '.reveal, .reveal-left, .reveal-right, .reveal-scale, .stagger-children';
    $$(sel, root || document).forEach(function (el) {
      if (!el.classList.contains('visible')) revealObserver.observe(el);
    });
  }

  // ============================================================
  // Header / Navigation
  // ============================================================
  register('header', function initHeader(root) {
    var nav = root.matches ? root : root.querySelector('.site-header');
    if (!nav || !nav.classList) {
      nav = document.getElementById('MainNav');
    }
    if (!nav) return;
    var isTransparent = nav.getAttribute('data-transparent') === 'true';

    function handleScroll() {
      if (!isTransparent) return;
      if (window.scrollY > 50) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    }
    on(window, 'scroll', handleScroll, { passive: true });
    handleScroll();

    // Mobile menu
    var toggle = nav.querySelector('[data-mobile-menu-toggle]');
    on(toggle, 'click', function () {
      var open = nav.classList.toggle('is-menu-open');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panel = document.getElementById('MobileMenu');
      if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    });

    // Cart toggle (delegated below also)
    $$('[data-cart-toggle]', nav).forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        Drawer.open();
      });
    });
  });

  // Also handle cart toggles outside the section (e.g. footer)
  on(document, 'click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cart-toggle]');
    if (btn) {
      e.preventDefault();
      Drawer.open();
    }
  });

  // ============================================================
  // Cart drawer + AJAX cart
  // ============================================================
  var Drawer = {
    el: null,
    open: function () {
      this.el = this.el || document.getElementById('CartDrawer');
      if (!this.el) { window.location = window.Shopify ? '/cart' : '/cart'; return; }
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      this.el = this.el || document.getElementById('CartDrawer');
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  register('cart-drawer', function initCartDrawer(root) {
    // Lift the drawer to be a direct child of <body> so its `position: fixed`
    // panel is always measured against the viewport. Inside Shopify's
    // `.shopify-section` wrapper (especially in the theme editor) an ancestor can
    // become the containing block and leave the panel detached from the right edge.
    if (root.parentElement && root.parentElement !== document.body) {
      document.body.appendChild(root);
    }
    $$('[data-cart-close]', root).forEach(function (btn) {
      on(btn, 'click', function () { Drawer.close(); });
    });
    bindCartLineControls(root);
  });

  function bindCartLineControls(root) {
    $$('[data-cart-increase]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var key = btn.getAttribute('data-key');
        var qtyEl = btn.parentElement.querySelector('[data-cart-line-qty]');
        var current = parseInt((qtyEl && qtyEl.textContent) || '0', 10);
        Cart.change(key, current + 1);
      });
    });
    $$('[data-cart-decrease]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var key = btn.getAttribute('data-key');
        var qtyEl = btn.parentElement.querySelector('[data-cart-line-qty]');
        var current = parseInt((qtyEl && qtyEl.textContent) || '0', 10);
        Cart.change(key, Math.max(0, current - 1));
      });
    });
    $$('[data-cart-remove]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        Cart.change(btn.getAttribute('data-key'), 0);
      });
    });
  }

  var Cart = {
    get: function () {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    },
    add: function (formData) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (r) { return r.json(); });
    },
    change: function (key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderCart(cart);
        return cart;
      });
    }
  };

  function renderCart(cart) {
    // Update item count badges
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count === 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });
    var label = document.querySelector('[data-cart-count-label]');
    if (label) label.textContent = '(' + cart.item_count + ')';

    // Render drawer body
    var body = document.querySelector('[data-cart-body]');
    var footer = document.querySelector('[data-cart-footer]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = renderEmpty();
      if (footer) footer.classList.add('hidden');
    } else {
      var html = '<div class="space-y-4" data-cart-items>';
      cart.items.forEach(function (item) { html += renderItem(item); });
      html += '</div>';
      body.innerHTML = html;
      if (footer) footer.classList.remove('hidden');
      bindCartLineControls(body);
    }
    var total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function renderEmpty() {
    return '<div class="flex flex-col items-center justify-center h-full text-center"><div class="w-16 h-16 rounded-full bg-navy/5 flex items-center justify-center mb-4"><svg class="w-8 h-8 text-grey" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/></svg></div><p class="font-heading text-xl text-navy mb-2">Your basket is empty</p><p class="text-grey text-sm">Add a mattress to start your sleep upgrade</p></div>';
  }

  function renderItem(item) {
    var img = item.image ? item.image.replace(/\.(jpg|jpeg|png|webp)/, '_160x.$1') : '';
    var props = '';
    (item.properties || []).forEach(function (prop) {
      var k = prop[0]; var v = prop[1];
      if (k && k.charAt(0) !== '_' && v) {
        props += '<p class="text-grey text-xs mt-0.5">' + escapeHtml(k) + ': ' + escapeHtml(v) + '</p>';
      }
    });
    var variantLine = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      variantLine = '<p class="text-grey text-xs mt-0.5">' + escapeHtml(item.variant_title) + '</p>';
    }
    return '<div class="flex gap-4 bg-cream-dark/50 rounded-xl p-4 border border-navy/5" data-cart-line-item data-key="' + item.key + '">' +
      '<a href="' + item.url + '" class="w-20 h-20 rounded-lg overflow-hidden bg-white shrink-0 relative">' +
        (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy" class="absolute inset-0 w-full h-full object-cover">' : '') +
      '</a>' +
      '<div class="flex-1 min-w-0">' +
        '<h3 class="font-heading text-base font-semibold text-navy truncate"><a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a></h3>' +
        variantLine + props +
        '<p class="text-gold font-semibold text-sm mt-1">' + formatMoney(item.final_price) + '</p>' +
        '<div class="flex items-center gap-3 mt-2">' +
          '<button type="button" class="w-7 h-7 rounded-full border border-navy/15 flex items-center justify-center text-navy text-sm" data-cart-decrease data-key="' + item.key + '" aria-label="Decrease">−</button>' +
          '<span class="text-sm font-medium text-navy w-4 text-center" data-cart-line-qty>' + item.quantity + '</span>' +
          '<button type="button" class="w-7 h-7 rounded-full border border-navy/15 flex items-center justify-center text-navy text-sm" data-cart-increase data-key="' + item.key + '" aria-label="Increase">+</button>' +
          '<button type="button" class="ml-auto text-grey" data-cart-remove data-key="' + item.key + '" aria-label="Remove"><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg></button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  // Delegated AJAX add for any form with data-ajax-add
  on(document, 'submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('disabled', '');
    var fd = new FormData(form);
    Cart.add(fd).then(function (added) {
      if (added && added.status >= 400) {
        if (btn) btn.removeAttribute('disabled');
        return;
      }
      return Cart.get();
    }).then(function (cart) {
      if (btn) btn.removeAttribute('disabled');
      if (cart) {
        renderCart(cart);
        Drawer.open();
      }
    });
  });

  // ============================================================
  // Hero — no init needed (CSS animations)
  // ============================================================
  register('hero', function (root) {
    observeReveals(root);
  });

  // ============================================================
  // Problem section — mobile scroll-over reveal
  // ============================================================
  register('problem', function (root) {
    observeReveals(root);
    var container = root.querySelector('[data-problem-container]');
    var overlay = root.querySelector('[data-problem-overlay]');
    if (!container || !overlay) return;

    function handleScroll() {
      if (window.innerWidth > 1024) return;
      var rect = container.getBoundingClientRect();
      var viewH = window.innerHeight;
      var trigger = viewH * 0.4;
      var raw = (trigger - rect.top) / (viewH * 0.35);
      var p = Math.min(Math.max(raw, 0), 1);
      var eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      overlay.style.transform = 'translateY(' + ((1 - eased) * 100) + '%)';
      overlay.style.opacity = String(eased);
    }
    on(window, 'scroll', handleScroll, { passive: true });
    handleScroll();
  });

  // ============================================================
  // Solution, Trade, Final — just reveal observers
  // ============================================================
  ['solution', 'product-showcase', 'trade-cta', 'final-cta'].forEach(function (type) {
    register(type, function (root) { observeReveals(root); });
  });

  // ============================================================
  // Trust — autoplay carousel
  // ============================================================
  register('trust', function (root) {
    observeReveals(root);
    var slides = $$('[data-trust-slide]', root);
    var dots = $$('[data-trust-dot]', root);
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var paused = false;
    var intervalSec = parseInt(root.getAttribute('data-autoplay') || '5', 10);

    function show(i) {
      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === i);
        s.setAttribute('aria-hidden', j === i ? 'false' : 'true');
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('trust__dot--active', j === i);
      });
      index = i;
    }
    function next() { show((index + 1) % slides.length); }
    function start() { stop(); timer = setInterval(function () { if (!paused) next(); }, intervalSec * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (dot, i) {
      on(dot, 'click', function () {
        show(i);
        paused = true;
        setTimeout(function () { paused = false; }, 8000);
      });
    });

    on(root, 'mouseenter', function () { paused = true; });
    on(root, 'mouseleave', function () { paused = false; });

    start();
    show(0);
  });

  // ============================================================
  // Product page — gallery, variant select, price update
  // ============================================================
  register('product', function (root) {
    var mains = $$('[data-product-main]', root);
    var thumbs = $$('[data-product-thumb]', root);
    thumbs.forEach(function (t) {
      on(t, 'click', function () {
        var idx = t.getAttribute('data-product-thumb');
        mains.forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-product-main') === idx);
        });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });

    // Variant switching
    var productScript = root.querySelector('[data-product-json]');
    var productData = null;
    try { productData = productScript ? JSON.parse(productScript.textContent) : null; } catch (e) {}
    if (!productData) return;

    var form = root.querySelector('[data-product-form]');
    if (!form) return;
    var variantInput = form.querySelector('[data-product-variant-id]');
    var optionInputs = $$('[data-product-option-input]', form);
    var priceEl = root.querySelector('[data-product-price]');
    var submitText = root.querySelector('[data-product-submit-text]');
    var submitBtn = root.querySelector('[data-product-submit]');

    function updateVariant() {
      if (!productData.variants) return;
      var selected = optionInputs.map(function (sel) { return sel.value; });
      var variant = productData.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === selected[i]; });
      });
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (submitText) {
        submitText.textContent = variant.available
          ? ('Add to Basket — ' + formatMoney(variant.price))
          : 'Sold out';
      }
      if (submitBtn) {
        if (variant.available) submitBtn.removeAttribute('disabled');
        else submitBtn.setAttribute('disabled', '');
      }
    }
    optionInputs.forEach(function (sel) { on(sel, 'change', updateVariant); });
  });

  // ============================================================
  // Collection — compare toggle
  // ============================================================
  register('collection', function (root) {
    observeReveals(root);
    var toggle = root.querySelector('[data-compare-toggle]');
    var panel = root.querySelector('[data-compare-panel]');
    var openLabel = root.querySelector('[data-compare-open]');
    var closeLabel = root.querySelector('[data-compare-close]');
    on(toggle, 'click', function () {
      if (!panel) return;
      var hidden = panel.classList.toggle('hidden');
      if (openLabel) openLabel.classList.toggle('hidden', !hidden);
      if (closeLabel) closeLabel.classList.toggle('hidden', hidden);
    });

    var filterForm = root.querySelector('[data-collection-filter-form]');
    if (filterForm) {
      var select = filterForm.querySelector('select');
      on(select, 'change', function () { filterForm.submit(); });
    }
  });

  // ============================================================
  // Bespoke — 3-step quote builder
  // ============================================================
  register('bespoke', function (root) {
    var stepper = root.querySelector('[data-bespoke-stepper]');
    var panes = $$('[data-bespoke-pane]', root);
    var steps = $$('[data-bespoke-step]', root);
    var bars = $$('[data-bespoke-step-bar]', root);
    var stepLabels = $$('[data-bespoke-step-label]', root);
    var nextBtns = $$('[data-bespoke-next]', root);
    var backBtns = $$('[data-bespoke-back]', root);

    var state = { step: 1, shape: '', needsCut: false, length: '', width: '', cut: '', mattress: '', mattressBase: 0 };

    function show(step) {
      state.step = step;
      panes.forEach(function (p) { p.classList.toggle('is-active', parseInt(p.getAttribute('data-bespoke-pane'), 10) === step); });
      steps.forEach(function (s) {
        var n = parseInt(s.getAttribute('data-bespoke-step'), 10);
        s.classList.toggle('is-active', n === step);
        s.classList.toggle('is-done', n < step);
        s.textContent = n < step ? '✓' : String(n);
      });
      bars.forEach(function (bar) {
        var n = parseInt(bar.getAttribute('data-bespoke-step-bar'), 10);
        bar.classList.toggle('bg-gold/40', n < step);
      });
      stepLabels.forEach(function (lbl) {
        var n = parseInt(lbl.getAttribute('data-bespoke-step-label'), 10);
        lbl.classList.toggle('text-navy', n === step);
        lbl.classList.toggle('text-grey', n !== step);
      });
      updateNextEnabled();
      updateSummary();
    }

    function updateNextEnabled() {
      nextBtns.forEach(function (btn) {
        var pane = btn.closest('[data-bespoke-pane]');
        var step = pane ? parseInt(pane.getAttribute('data-bespoke-pane'), 10) : 0;
        var ok = false;
        if (step === 1) ok = !!state.shape;
        else if (step === 2) ok = !!(state.length && state.width);
        if (ok) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
      });
    }

    function updateSummary() {
      var dims = state.length && state.width ? state.length + ' × ' + state.width + 'cm' : '—';
      var shapeEl = root.querySelector('[data-summary-shape]');
      var dimsEl = root.querySelector('[data-summary-dims]');
      var matEl = root.querySelector('[data-summary-mattress]');
      var priceEl = root.querySelector('[data-summary-price]');
      if (shapeEl) shapeEl.textContent = state.shape || '—';
      if (dimsEl) dimsEl.textContent = dims;
      if (matEl) matEl.textContent = state.mattress || '—';
      if (priceEl) {
        var base = state.mattressBase || 0;
        var surcharge = (state.shape && state.shape.toLowerCase() !== 'rectangle') ? 50 : 0;
        priceEl.textContent = base > 0 ? ('From £' + (base + surcharge)) : '—';
      }
      var preview = root.querySelector('[data-bespoke-shape-preview]');
      var caption = root.querySelector('[data-bespoke-shape-caption]');
      if (preview && state.shape) {
        var selectedShape = $$('[data-bespoke-shape]', root).find(function (input) { return input.value === state.shape; });
        if (selectedShape) {
          var label = selectedShape.closest('label');
          var svgIcon = label && label.querySelector('.bespoke-shape__icon');
          if (svgIcon && preview && caption) {
            preview.innerHTML = svgIcon.innerHTML;
            caption.textContent = state.shape + (dims !== '—' ? ' — ' + dims : '');
          }
        }
      }
      // Cut row visibility
      var cutRow = root.querySelector('[data-bespoke-cut-row]');
      if (cutRow) cutRow.classList.toggle('hidden', !state.needsCut);
    }

    // Shape select
    $$('[data-bespoke-shape]', root).forEach(function (input) {
      on(input, 'change', function () {
        state.shape = input.value;
        state.needsCut = input.getAttribute('data-needs-cut') === 'true';
        $$('.bespoke-shape', root).forEach(function (lbl) { lbl.classList.remove('is-selected'); });
        var label = input.closest('.bespoke-shape');
        if (label) label.classList.add('is-selected');
        updateNextEnabled();
        updateSummary();
      });
    });

    // Mattress select
    $$('[data-bespoke-mattress]', root).forEach(function (input) {
      on(input, 'change', function () {
        state.mattress = input.value;
        var label = input.closest('.bespoke-mattress');
        var priceText = label ? label.querySelector('.font-heading.text-xl') : null;
        if (priceText) {
          var match = priceText.textContent.match(/£(\d+)/);
          if (match) state.mattressBase = parseInt(match[1], 10);
        }
        $$('.bespoke-mattress', root).forEach(function (lbl) { lbl.classList.remove('is-selected'); });
        if (label) label.classList.add('is-selected');
        updateSummary();
      });
    });

    // Dimension inputs
    ['BespokeLength', 'BespokeWidth', 'BespokeCut'].forEach(function (id) {
      var el = root.querySelector('#' + id);
      on(el, 'input', function () {
        if (id === 'BespokeLength') state.length = el.value;
        else if (id === 'BespokeWidth') state.width = el.value;
        else state.cut = el.value;
        updateNextEnabled();
        updateSummary();
      });
    });

    // Stepper buttons
    steps.forEach(function (s) {
      on(s, 'click', function () {
        var n = parseInt(s.getAttribute('data-bespoke-step'), 10);
        if (n < state.step) show(n);
      });
    });
    nextBtns.forEach(function (btn) { on(btn, 'click', function () { show(state.step + 1); }); });
    backBtns.forEach(function (btn) { on(btn, 'click', function () { show(state.step - 1); }); });

    show(1);
  });

  // ============================================================
  // Page / 404 / search / list-collections — just reveals
  // ============================================================
  ['page', 'main-cart', 'search'].forEach(function (type) {
    register(type, function (root) { observeReveals(root); });
  });

  // ============================================================
  // Boot
  // ============================================================
  function boot() {
    setupRevealObserver();
    observeReveals(document);
    initAllSections(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // ============================================================
  // Theme editor re-initialization
  // ============================================================
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type]') || event.target;
    if (section && section.getAttribute('data-section-type')) {
      initSection(section);
    }
    observeReveals(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    // Reveal observer cleans itself; no per-section teardown needed currently.
  });

  document.addEventListener('shopify:section:select', function (event) {
    var hero = event.target.querySelector('.hero');
    if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Expose for debugging
  window.SleepClubTheme = { Cart: Cart, Drawer: Drawer, render: renderCart };
})();
